import React from 'react';
import styled from 'styled-components';

export const Flex = styled.div`
  display: flex;
`;

const StyledIcon = styled.img`
  display: inline-block;
  height: 12px;
`;

export const Icon = ({ icon }) => <StyledIcon src={icon} />;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/ui/index.js